import { useFormContext } from "react-hook-form";
import type { BlockEditorFormValues, Section } from "../types";


/**
 * Get the section and index of a block by its ID.
 * @param id
 */
export function useBlockIndexSection(id: string): { section: Section; index: number } {
	const { watch } = useFormContext<BlockEditorFormValues>();
	const beforeBlocks = watch("content.beforeBlocks");
	const insideBlocks = watch("content.insideBlocks");
	const afterBlocks = watch("content.afterBlocks");

	const beforeIndex = beforeBlocks.findIndex((block) => block.id === id);
	if (beforeIndex !== -1) return { section: "before", index: beforeIndex };

	const insideIndex = insideBlocks.findIndex((block) => block.id === id);
	if (insideIndex !== -1) return { section: "inside", index: insideIndex };

	const afterIndex = afterBlocks.findIndex((block) => block.id === id);
	if (afterIndex !== -1) return { section: "after", index: afterIndex };

	return { section: "inside" as Section, index: -1 };
}
